module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-italic.57dd34a.woff";